import { PageDesignIBMStoreDetails } from './data-contracts';
import { HttpClient, RequestParams, TraceDataType } from './http-client';

import { loggerCan } from '@/data/utils/loggerUtil';
import { logger } from '@/logging/logger';

export class PageDesign<SecurityDataType = unknown> {
	http: HttpClient<SecurityDataType>;

	constructor(http: HttpClient<SecurityDataType>) {
		this.http = http;
	}

	/**
	 * @description Finds a product display layout page by product ID.
	 *
	 * @tags Page Design
	 * @name PageDesignByProductId
	 * @summary Get layout by product ID
	 * @request GET:/store/{storeId}/page_design
	 * @secure
	 * @response `200` `PageDesignIBMStoreDetails` The requested completed successfully.
	 * @response `400` `void` Bad request. The request could not be understood by the server due to malformed syntax.
	 * @response `401` `void` Not authenticated. The user session is not valid.
	 * @response `403` `void` The user is not authorized to perform the specified request.
	 * @response `500` `void` Internal server error. For details, see the server log files.
	 */
	pageDesignByProductId = (
		storeId: string,
		query: {
			/** The query name. */
			q: 'byObjectIdentifier' | 'byLayoutId' | 'byProductId' | 'byLayoutActivityId';
			/** The product ID. */
			productId: string;
			/** The layout activity ID. */
			layoutActivityId: string;
			/** The layout ID. */
			layoutId: string;
			/** The pageGroup. */
			pageGroup: string;
			/** The deviceClass. */
			deviceClass: string;
			/** The object identifier */
			objectIdentifier: string;
		},
		params: RequestParams = {}
	) => {
		const { _requestId: requestId, skipErrorLogging, ..._params } = params as any;
		let traceData: TraceDataType | undefined;

		if (
			loggerCan('trace') &&
			(!this.http.traceDetails || this.http.traceDetails['pageDesignByProductId'])
		) {
			traceData = {
				requestId,
				msg: 'API request',
				url: `${this.http.baseUrl}/store/${storeId}/page_design`,
				params: _params,
				query: query,
				methodName: 'pageDesignByProductId',
			};
			logger.trace(traceData);
		}
		return this.http.request<PageDesignIBMStoreDetails, void>({
			path: `/store/${storeId}/page_design`,
			method: 'GET',
			query: query,
			secure: true,
			format: params.format ?? 'json',
			storeId,
			traceData,
			skipErrorLogging,
			..._params,
		});
	};
}
